import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormHelperText,
    TextField,
} from "@mui/material";
import * as React from "react";
import * as ReactDOM from "react-dom";

interface ConfirmModalProps {
    title?: string;
    content?: string;
    okText?: string;
    cancelText?: string;
    textValidator?: string;
    onOk(): void;
}

interface StaticDialogProps extends ConfirmModalProps {
    destroy(): void;
}

export class StaticModal {
    static confirm(config: ConfirmModalProps) {
        const defaultConfig = {
            title: "Dialog",
            content: "Are you sure?",
            okText:  "Ok",
            cancelText: "Cancel",
            textValidator: null,
        };
        const configToPass = { ...defaultConfig, ...config } as any;

        const div = document.createElement("div");
        document.body.appendChild(div);

        const destroy = () => {
            const unmountResult = ReactDOM.unmountComponentAtNode(div);

            if (unmountResult && div.parentNode) {
                div.parentNode.removeChild(div);
            }
        }

        ReactDOM.render(<StaticDialog destroy={destroy} {...configToPass}/>, div);
    }
}

class StaticDialog extends React.Component<StaticDialogProps, any> {
     constructor(props) {
        super(props);

        this.state = {
            textValidatorText: "",
            haveValidatorError: false,
        };
    }

     onConfirm = () => {
        if (this.props.textValidator && this.props.textValidator !== this.state.textValidatorText) {
            return this.setState({ haveValidatorError: true });
        }

        this.props.onOk();
        this.props.destroy();
    }

     changeTextValidatorText = (e) => this.setState({ textValidatorText: e.target.value });

     render() {
        return <Dialog
            open={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClose={this.props.destroy}
        >
            <DialogTitle id="alert-dialog-title">{this.props.title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {this.props.content}
                </DialogContentText>

                {this.props.textValidator &&
                    <div style={{ marginTop: 10 }}>
                        <p>To confirm, type <b>{this.props.textValidator}</b> in the field below.</p>

                        <TextField
                            id="standard-name"
                            label="Validation text"
                            value={this.state.textValidatorText}
                            onChange={this.changeTextValidatorText}
                            style={{ width: "100%" }}
                            error={this.state.haveValidatorError}
                        />
                        {this.state.haveValidatorError && <FormHelperText id="component-error-text" style={{ color: "red" }}>
                            Invalid validation text
                        </FormHelperText>}
                    </div>
                }
            </DialogContent>
            <DialogActions>
                <Button disableElevation color="primary" onClick={this.props.destroy}>
                    {this.props.cancelText}
                </Button>
                <Button disableElevation color="primary" autoFocus onClick={this.onConfirm}>
                    {this.props.okText}
                </Button>
            </DialogActions>
        </Dialog>
    };
}
